import DapAttenteFormController from './dap-attente.form.controller';

export default {
    template: require('./dap-attente.form.html'),
    controller: DapAttenteFormController
};
